var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.totalPages > 1,
          expression: "totalPages > 1",
        },
      ],
      staticClass: "flex justify-center sm:justify-between items-center gap-md",
    },
    [
      _c("div", { staticClass: "w-3xl sm:flex justify-start hidden" }, [
        _c(
          "a",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.currentPage > 1,
                expression: "currentPage > 1",
              },
            ],
            staticClass: "btn btn--primary btn--outline",
            attrs: { href: "#" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.$emit("previous-page")
              },
            },
          },
          [_vm._v(" Vorige ")]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex items-center justify-center gap-xxs" },
        _vm._l(_vm.totalPages, function (i) {
          return _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: i < _vm.currentPage + 5 && i > _vm.currentPage - 5,
                  expression: "i < currentPage + 5 && i > currentPage - 5",
                },
              ],
              key: i,
              staticClass:
                "font-semibold text-gray-500 w-md h-md bg-transparent cursor-pointer flex items-center justify-center hover:bg-gray-700",
              class: {
                "bg-primary-400 text-gray-900": i === _vm.currentPage,
              },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.$emit("go-to-page", { page: i })
                },
              },
            },
            [_vm._v("\n            " + _vm._s(i) + "\n        ")]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "w-3xl hidden sm:flex justify-end" }, [
        _c(
          "a",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.currentPage < _vm.totalPages,
                expression: "currentPage < totalPages",
              },
            ],
            staticClass: "btn btn--primary btn--outline",
            attrs: { href: "#" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.$emit("next-page")
              },
            },
          },
          [_vm._v(" Volgende ")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }